module.exports = __webpack_public_path__ + "img/album21_28.7da11272.jpg";